
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';


import { Link } from "react-router-dom";
import francia from "../../assets/francia.png";
import magyar from "../../assets/magyar.png";
import arrow from "../../assets/arrow.png"

function FranciaMagyar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Francia magyar fordító</title>
                <meta name='description' content="Ingyenes francia magyar fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Francia magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/francia-magyar-fordito" />
            </Helmet>
            <h1>Francia magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>


            <section>
                <div className="sectionhead">
                    <h2>A francia nyelvről</h2>
                    <img src={francia} alt="Francia zászló"></img>
                </div>

                <p>A francia, egy neo-latin nyelv, az egyik legszélesebb körben beszélt nyelv a világon, több mint 275 millió beszélővel szerte a világon. A francia 29 ország hivatalos nyelve, köztük Franciaország, Belgium, Svájc, Kanada és számos afrikai ország.</p>

                <p>A nyelv gyökerei a latinból erednek, de az évszázadok során önálló nyelvvé fejlődött, saját nyelvtannal, szókinccsel és kiejtéssel. Eleganciájáról, pontosságáról és gazdag irodalmi hagyományairól ismert.</p>

               <p>Nyelvtana az angolhoz képest viszonylag összetett szerkezetet követ. Ez egy mérsékelten flektált nyelv, ami azt jelenti, hogy a szavak alakja megváltozik a nem, a szám és az idő megjelölésére. A főneveknek két nemük van, hím és nőneműek, a mellékneveknek pedig nemben és számban meg kell egyezniük az általuk módosított főnevekkel.</p>

                <p>A francia kiejtés kihívást jelenthet a nem anyanyelvi beszélők számára az orrhangok és a finom magánhangzó-megkülönböztetések miatt. A nyelvben a liaisonok is jellemzőek, ahol egy szó utolsó mássalhangzója a következő szóval kapcsolódik össze a gördülékenyebb beszédfolyamat érdekében.</p>

                <p>Szókincse változatos, és számos latin, görög, angol és más nyelvekből származó kölcsönszót tartalmaz. A francia nyelv a művészetekre, a divatra, a konyhára és a diplomáciára gyakorolt hatásáról ismert, és számos francia szót nemzetközi szinten is átvettek.</p>

                <p>A francia írásrendszer a latin ábécét használja, diakritikus jelekkel, például ékezetekkel és cedillákkal. A francia helyesírás néha eltérhet a kiejtéstől, ami a tanulók számára még bonyolultabbá teszi a nyelvtanulást.</p>

                <p>A francia nyelv gazdag irodalmi hagyományokkal rendelkezik, olyan neves szerzők, mint Victor Hugo, Molière és Voltaire járultak hozzá az irodalom gazdagságához. A diplomácia és az olyan nemzetközi szervezetek nyelveként is elismert, mint az ENSZ és a Nemzetközi Olimpiai Bizottság.</p>
             
                <div className="sectionbottom">
                    <Link to="/magyar-francia-fordito">Magyar francia fordító</Link>

                    <img src={francia} alt="francia zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>

                </div>
          
            </section>
        </>

    )
}

export default FranciaMagyar;